export default __webpack_public_path__ + "ac09c59bd8212635d45efb53da8ef504.png";